export const storeData = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // Silently fail - storage errors are not critical
  }
};

export const retrieveData = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return JSON.parse(value);
    }
  } catch (error) {
    // Silently fail - storage errors are not critical
  }
};

export const removeData = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    // Silently fail - storage errors are not critical
  }
};

export const clearStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    // Silently fail - storage errors are not critical
  }
};
